<template>
  <div>
    <b-select
      placeholder="Seleccione un panel"
      size="is-large"
      expanded
      @input="navigateToPanel"
      v-model="panelSelection"
    >
      <option v-for="[id, panel] in paneles" :key="id" :value="id">
        {{ panel.title }}
      </option>
    </b-select>
  </div>
</template>

<script>
import rootSchema from '@/schema'

export default {
  name: 'PanelSelector',
  props: {
    schema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      panelSelection: this.$route.params.slug
    }
  },
  computed: {
    paneles() {
      return Object.entries(rootSchema.properties)
    }
  },
  methods: {
    navigateToPanel(id) {
      this.$router.push({
        name: 'Panel',
        params: {
          slug: id
        }
      })
    }
  }
}
</script>
